export default __webpack_public_path__ + "static/innovationBlogImage-541e99eed487555e2103178a7bf599c0.png";